var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "b-form-checkbox",
          {
            staticClass: "font-weight-extra-bold",
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.privacy,
              callback: function($$v) {
                _vm.privacy = $$v
              },
              expression: "privacy"
            }
          },
          [
            _vm.agbShort
              ? [
                  _vm._v("\n\t\t\t\tIch akzeptiere die "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/info/nutzungsbedingungen",
                        target: "_blank"
                      }
                    },
                    [_vm._v("Nutzungsbedingungen")]
                  ),
                  _vm._v(".\n\t\t\t")
                ]
              : [
                  _vm._v("\n\t\t\t\tIch akzeptiere die "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/info/nutzungsbedingungen",
                        target: "_blank"
                      }
                    },
                    [_vm._v("Nutzungsbedingungen")]
                  ),
                  _vm._v("\n\t\t\t\tund "),
                  _c("a", { attrs: { href: "/info/agb", target: "_blank" } }, [
                    _vm._v("AGB")
                  ]),
                  _vm._v(".\n\t\t\t")
                ]
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2" }, [
      _vm._v("\n\t\tDie "),
      _c("a", { attrs: { href: "/info/datenschutz", target: "_blank" } }, [
        _vm._v("Datenschutzerklärung")
      ]),
      _vm._v(" findest du hier.\n\t")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }